<template>
  <b-modal
    id="set_help"
    title="AJUDA"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <label-required-field label="Título" />
          <b-input ref="autofocus" :disabled="updating" v-model="title" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label-required-field label="URL" />
          <b-input v-model="link" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <warning-required-fields />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <errors-messages :errors="errors" />
        </b-col>
      </b-row>
      <b-row align-h="between">
        <b-col cols="auto">
          <v-btn class="v-primary" @click="$bvModal.hide('set_help')">
            VOLTAR
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn type="submit" class="v-success ml-1"> SALVAR </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import LabelRequiredField from "../components/LabelRequiredField.vue";
import ErrorsMessages from "../components/ErrorsMessages.vue";
import WarningRequiredFields from "../components/WarningRequiredFields.vue";

import api from "../../services/api";

import toast from "../../components/ToastNotification";

export default {
  name: "SetHelp",

  components: {
    LabelRequiredField,
    ErrorsMessages,
    WarningRequiredFields,
  },

  props: {
    help: Object,
  },

  data() {
    return {
      errors: [],
      updating: false,
      loading: false,

      id: "",
      title: "",
      link: "",
    };
  },

  watch: {
    help(hel) {
      console.log("watch");
      if (!hel) {
        this.updating = false;
        this.id = "";
        this.title = "";
        this.link = "";
        return;
      }

      this.updating = true;
      this.id = hel.id;
      this.title = hel.title;
      this.link = hel.link;

      this.$bvModal.show("set_help");
    },
  },

  methods: {
    async evOnShow() {
      this.errors = [];
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = { title: this.title, link: this.link };
        const response = await api.post("/help", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("set_help");
          this.$emit("success");
          toast(message, "success");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>